import React, { useEffect, useState } from 'react'
import { EventType } from '@azure/msal-browser';
import {
    LOGIN_REQUEST,
    PUBLIC_CLIENT_APPLICATION,
    TOKEN_REQUEST,
    GRAPH_CONFIG
} from '../../msalConfig'

async function callMsGraph(accessToken) {
    const headers = new Headers();
    const bearer = `Bearer ${accessToken}`;

    headers.append("Authorization", bearer);

    const options = {
        method: "GET",
        headers: headers
    };

    return fetch(GRAPH_CONFIG.graphMeEndpoint, options)
        .then(response => response.json())
        .catch(error => console.log(error));
}

export default function Page() {

    const [token, setToken] = useState(null);

    useEffect(() => {
        if (token) {
            callMsGraph(token).then((response) => {
                console.log(response);
            });
        }
    }, [token])

    const handleSignIn = async () => {
        const loginResponse = await PUBLIC_CLIENT_APPLICATION.loginPopup(LOGIN_REQUEST);
        if (loginResponse.account) {
            PUBLIC_CLIENT_APPLICATION.setActiveAccount(loginResponse.account);
        }
        const tokenResponse = await PUBLIC_CLIENT_APPLICATION.acquireTokenSilent(TOKEN_REQUEST);
        setToken(tokenResponse.accessToken);
    }

    const handleSignOut = async () => {
        window.askUnload = false;
        await PUBLIC_CLIENT_APPLICATION.logoutRedirect({
            onRedirectNavigate: (url) => {
                return false;
            }
        });
        window.location.href = '/';
    }

    if (!PUBLIC_CLIENT_APPLICATION.getActiveAccount() && PUBLIC_CLIENT_APPLICATION.getAllAccounts().length > 0) {
        PUBLIC_CLIENT_APPLICATION.setActiveAccount(PUBLIC_CLIENT_APPLICATION.getActiveAccount()[0]);
    }

    PUBLIC_CLIENT_APPLICATION.addEventCallback((event) => {
        if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
            window.askUnload = false;
            window.parent.location.href = '/';
        }
    });

    PUBLIC_CLIENT_APPLICATION.handleRedirectPromise()

}